
import Vue, { PropType } from 'vue';
import BorrowerConfirmModal from '@/components/submit-page/borrower-confirm-modal.vue';

export default Vue.extend({
	name: 'ReviewLender',
	components: {
		BorrowerConfirmModal
	},
	props: {
		notYetReadyForReview: {
			type: Boolean as PropType<boolean | null>,
			default: null
		},
		isLenderReview: {
			type: Boolean as PropType<boolean | null>,
			default: null
		},
		isReadyForBorrowerSubmission: {
			type: Boolean as PropType<boolean | null>,
			default: null
		},
		isValidatingOrSubmitting: {
			type: Boolean as PropType<boolean>,
			default: false
		},
		itemLabel: {
			type: String as PropType<string | null>,
			default: null
		},
		canSubmitBeforeLenderReview: {
			type: Boolean as PropType<boolean>,
			default: false
		},
		preSubmitMessage: {
			type: String as PropType<string | null>,
			default: null
		},
		canLenderMarkReadyForLenderReview: {
			type: Boolean as PropType<boolean | null>,
			default: null
		}
	},
	data() {
		return {};
	},
	computed: {},
	mounted() {},
	methods: {
		markReadyForReview() {
			this.$emit('mark-ready-for-review');
		},
		readyForBorrowerToSubmit() {
			this.$emit('readyForBorrowerToSubmit');
		},
		submitApplication() {
			this.$emit('submitApplication');
		}
	}
});
